Vue.asyncComponent('cms-dashboard-display-errors-status', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        isEnabled: {
            type: Boolean,
            default: false,
        },
    },
}, 'cms/dashboard/live/cms-dashboard-display-errors-status.html');
